export default {
  components: {},
  methods: {}
};
